module.exports = __webpack_public_path__ + "img/gb930.prt.eb38cd4b.jpg";